export const inputValidators = {

    methods: {

        validateOutputIdentificationNameCharInput(event) {
            let check = /^[0-9A-Za-z\+\-_="]+$/.test(event.target.value);
            if (check === false) {
                this.form.output_identification_name = this.form.output_identification_name.replace(/[^0-9A-Za-z\+\-_=]/g, '');
            }
        },

        validateDisplayNameCharInput(event) {
            this.form.display_name = this.form.display_name.replace('"', '');
        },

        validateDisplayDescriptionCharInput(event) {
            this.form.display_description = this.form.display_description.replace('"', '');
        }

    }

}
